import { computed } from 'vue';
import { useStore } from 'vuex';
import { useZoomSettingProvider } from '@/composable/user/lead/zoom-setting-provider';
import { key } from '@/store/index';
import { TCtiType } from '@/types';

const useActiveCti = (skipMiitelAuthFetching = false) => {
  const store = useStore(key);
  let promiseByFetch: Promise<unknown> | null = null;
  if (!skipMiitelAuthFetching) {
    promiseByFetch = store.dispatch('user/getMiitelAuthAction');
  }
  const { inject: injectZoomSetting } = useZoomSettingProvider();
  const { zoomSetting = null } = injectZoomSetting() || {};

  const activeCti = computed<TCtiType>(() =>  {
    if (store.getters['user/miitelEnabled']) return 'miitel';
    if (zoomSetting?.value?.useZoomPhone) return 'zoom';
    return null;
  });

  return {
    promiseByFetch,
    activeCti,
  };
};

export {
  useActiveCti,
};
